export default __webpack_public_path__ + "assets/739da9d56a7ee9d56ab2a3797b1ed6e7.svg";